export const SIZES = ["small", "default"] as const;
